import { useMemo } from 'react';

import { User } from '@/api/auth';
import { getUserVipGroup } from '@/helpers/vip';

export const useUserVipLevel = (user?: User) => {
  const userVipLevel = useMemo(() => {
    if (!user?.statuses) return;

    return getUserVipGroup(user.statuses);
  }, [user]);

  return userVipLevel;
};
